// projectAtomsEnum — 0110ae08f5ed3366aee22cb48823850beb045e3aa683d4c03d2b5b235f93409b
/**
 * Project atom type enum (codegen).
 */

export enum Atoms {
  AdditionalArticleInfo = "AdditionalArticleInfo",
  ImportProtocol = "ImportProtocol",
  InstrumentInfo = "InstrumentInfo",
  OrderInfo = "OrderInfo",
  OrderPositions = "OrderPositions",
  PositionInfo = "PositionInfo",
  PositionMeta = "PositionMeta",
  PresetInfo = "PresetInfo",
  PresetList = "PresetList",
  PriceDataInfo = "PriceDataInfo",
  PriceParameters = "PriceParameters",
  RecentImports = "RecentImports",
  UserOptionInfo = "UserOptionInfo",
  UserOptionsList = "UserOptionsList",
}
